<template>
  <div class="container ">
    <div class="flex">
      <div class="tip">
        <h3>拍照须知：</h3>
        <p>1. <span>请保持人像处于画面正中；</span></p>
        <p>2. <span>请保持摄像头为开启状态；</span></p>
        <p>3. <span>请勿选择禁用摄像头，点击禁止后，会影响您的学习记录；</span></p>
        <p>4. <span>禁止摄像头后，请在标签栏中找到，摄像头图标，打开之后选择允许之后刷新页面；</span></p>
      </div>

      <div class="tip">
        <h3>签到流程：</h3>
        <p>1. <span style="color: red">点击左侧签到拍照按钮；</span></p>
        <p>2. <span>在右侧确认照片清晰无误后,请点击 <span style="color: red">签到成功，开始学习</span> 按钮；</span></p>
        <p>3. <span>如右侧照片显示不正常，请点击<span style="color: red">电脑签到有误，微信扫码</span>按钮 ，并打开 <span
            style="color: red">微信，扫描二维码，进行拍照签到</span> ，扫码成功后显示签到照片，再次点击<span style="color: red">签到成功，开始学习</span>按钮；</span></p>
        <p>4. <span>如果手机拍照后，照片还是不清晰，请点击微信端重新拍摄即可。</span> </p>
      </div>

    </div>

    <div class="flex  flex_justify-center">
      <div class="container-box">
        <div class="m-t-20">
          <div class="text-center video-module">
            <video id="videoArea" width="100%" height="100%" autoplay="autoplay"></video>
            <canvas id="canvas"></canvas>

          </div>
        </div>
        <div class="text-center m-t-20">
          <el-button type="danger" @click="uploadAliPhoto()" :loading="isUploadAliPhoto">签到拍照</el-button>
        </div>
      </div>

      <div class="container-box" v-show="!isShowQrCode">
        <div class="m-t-20">
          <div class="text-center video-module">
            <img v-if="cameraUrl" style="height:100%;width: 100%;" :src="cameraUrl" alt="">
            <div v-else style="width: 100%;height: 100%" class="flex flex_align-items flex_justify-center">
              <span style="color: #000000">暂无拍照图</span>
            </div>
          </div>
        </div>
        <div class="text-center" style="display: flex;flex-direction: column;width: 70%;margin: 10px auto 0;">
          <el-button type="success" @click="startClear()" :loading="isUploadPhoto">签到成功，开始学习</el-button>
          <el-button class="w-el-btn" type="warning" @click="setQrCode()" :loading="isUploadPhoto">电脑签到有误，微信扫码</el-button>
        </div>
      </div>

      <div v-show="isShowQrCode" class="container-box"
           style="flex-direction: column;display: flex;align-items: center;justify-content: center">
        <QrCode ref="qrCodeDiv"></QrCode>
        <div style="display: flex;align-items: center">
          <el-button type="primary" icon="el-icon-refresh" @click="clickRefresh">刷新</el-button>
          <el-button style="margin-left: 10px" icon="el-icon-arrow-left" @click="clickQrCodeBack">返回</el-button>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
import {photoConfig} from "@/views/video/mixins/mixins-photo-config";
import QrCode from "@/views/video/components/QrCode";

export default {
  components: {
    QrCode
  },
  props: {
    currenStudySectionId: String,
    currentSectionObj: Object,
    isVideoEnd: Boolean
  },
  mounted() {
  },
  created() {
    this.openMedia()
    this.currentTime = new Date().getTime()

  },
  data() {
    return {
      imageUrl: '',
      cameraUrl: '',
      isUploadAliPhoto: false,
      isUploadPhoto: false,
      isShowQrCode: false,
      websocket: null,
      timer: null,
      currentTime: ''
    }
  },
  beforeDestroy() {
    this.closeVideo();
    clearInterval(this.timer)
  },
  mixins: [photoConfig],
  methods: {
    clickQrCodeBack() {
      this.isShowQrCode = false
      this.$refs.qrCodeDiv.clearQRCode()
      clearInterval(this.timer)
      this.timer = null
    },
    // 刷新
    clickRefresh() {
      let date = new Date()
      // 清除定时器
      clearInterval(this.timer)
      this.setIntervalInit()
      // 每次更新前先清除二维码
      this.$refs.qrCodeDiv.clearQRCode()
      // 生成二维码
      this.$refs.qrCodeDiv.bindQRCode(this.currentTime, this.currentSectionObj.id, this.currentSectionObj.studySection.id, this.currentSectionObj.pxbId,this.currentSectionObj.pxbName, localStorage.getItem('token') )
    },
    clearAdminPhoto() {
      // 签到完成清除定时器
      if(this.timer) clearInterval(this.timer);
      this.timer = null;
      // 清除后台签到照片
      this.$post(this.$API.REMOVE_MEMBER_SECTION_PHOTO_MINI_INFO, {
        memberSectionId: this.currentSectionObj.id
      }).then(res => {
        console.log(res)
      })
    },
    startClear() {
      if (!this.cameraUrl) return this.$message({
        type: 'error',
        message: '请先签到'
      });

      // 清除后台签到照片
      this.clearAdminPhoto()
      this.currentTime = ''
      // 判断是开始拍照还是结束拍照
      if (!this.isVideoEnd)
        this.$emit('changeStart');
      else
        this.$emit('changeEnd');
    },
    async setQrCode() {
      await this.clearAdminPhoto()
      this.setIntervalInit()
      this.isShowQrCode = true
      this.$refs.qrCodeDiv.bindQRCode(this.currentTime, this.currentSectionObj.id, this.currentSectionObj.studySection.id, this.currentSectionObj.pxbId,this.currentSectionObj.pxbName, localStorage.getItem('token') )
    },
    // 开启定时器，请求接口
    setIntervalInit() {
      this.timer =  setInterval(() => {
       this.$get(this.$API.GET_MEMBER_SECTION_PHOTO_MINI_INFO, {
         memberSectionId: this.currentSectionObj.id,
         time: this.currentTime
       }).then(res => {
         if(res.code === 200) {
           this.currentTime = res.data.time
           if(res.data && res.data.memberSectionPhoto) {
             this.cameraUrl = res.data.memberSectionPhoto.photo
             this.isShowQrCode = false
             this.$refs.qrCodeDiv.clearQRCode()
             clearInterval(this.timer)
           }
         }
       })
      }, 1000)
    }
    /*websocketInit(membersectionId) {
      // 创建webSoket连接
      let _this = this
      //判断当前浏览器是否支持WebSocket
      if ('WebSocket' in window) {
        //改成你的地址
        _this.websocket = new WebSocket("wss://www.sxbicsp.com/api/websocket/" + membersectionId);
      } else {
        alert('当前浏览器 Not support websocket')
      }

      //连接发生错误的回调方法
      _this.websocket.onerror = function () {
        //jp.info("WebSocket连接发生错误");
        console.log("WebSocket连接发生错误");
      };

      //连接成功建立的回调方法
      _this.websocket.onopen = function () {
        console.log("WebSocket连接成功");
      }

      //连接关闭的回调方法
      _this.websocket.onclose = function () {
        console.log("WebSocket连接关闭");
        if (!_this.isCloseWs)
          _this.websocket = new WebSocket("wss://www.sxbicsp.com/api/websocket/" + membersectionId);
      }

      //接收到消息的回调方法
      _this.websocket.onmessage = function (event) {
        let data = event.data;
        console.log(data, '收到得消息')
      }

      //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = function () {
        _this.isCloseWs = true
        _this.closeWebSocket();
      }
    },
    // 关闭socket连接
    closeWebSocket() {
      this.websocket.close();
    },*/
  }
}

</script>

<style scoped lang="scss">
.container {
  width: 60%;
  background: #FFFFFF;
  padding: 30px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.container-box {
  margin: 0 30px;
}

.text-center {
  text-align: center;
}

.m-t-20 {
  margin-top: 20px;
}

.video-module {
  width: 300px;
  height: 220px;
  margin: 0 auto;
  padding: 5px;
  border: 1px solid;
  border-radius: 5px;
}

.btn {
  font-weight: 400;
  text-align: center;
  line-height: 1.5;
  border-radius: 2px;
  padding: 5px 20px;
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.btn-custom, .btn-custom:disabled:hover {
  background-color: #2196f3;
  border-color: #2196f3;
  color: #FFF;
}

.btn-danger, .btn-danger:disabled:hover {
  background-color: #e96154;
  border-color: #e96154;
  color: #FFF;
}

.tip {
  margin-top: $spacing-row-base;
  margin-bottom: 20px;
  font-size: $font-size-md;
  line-height: 30px;
  flex: 1;
  margin-left: 10px;

  p {
    padding-left: $spacing-row-sm;
  }
}

.el-button + .el-button {
  margin-left: 0;
}

.w-el-btn {
  margin-top: 10px;
}

#canvas{
  position: relative;
  z-index: -1;
}
</style>
